import capitalize from '@mui/utils/capitalize';
export default capitalize;


//////////////////
// WEBPACK FOOTER
// ../@mui/material/utils/capitalize.js
// module id = 17
// module chunks = 25